module.exports = __webpack_public_path__ + "static/media/ant.b29324c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Res/ant.svg
// module id = 442
// module chunks = 0